module.exports = __webpack_public_path__ + "static/media/bills-transform.29a0914f.png";